import React from 'react';
import { Chip } from '@c2fo/liquidity';
import type { ChipProps } from '@c2fo/liquidity';

export type StatusBadgeType = 'primary' | 'error' | 'warning' | 'info' | 'default';

interface StatusBadgeProps {
  type: StatusBadgeType;
  label: string;
  size?: ChipProps['size'];
  variant?: ChipProps['variant'];
  'aria-label'?: string;
}

/**
 * Reusable StatusBadge component for consistent status indicators
 * Matches old admin badge styling with Liquidity Chip component
 */
export const StatusBadge: React.FC<StatusBadgeProps> = ({
  type,
  label,
  size = 'xs',
  variant = 'filled',
  'aria-label': ariaLabel,
}) => {
  return <Chip type={type} variant={variant} size={size} label={label} aria-label={ariaLabel || `Status: ${label}`} />;
};
